import { Component, HostBinding, OnInit } from '@angular/core';

@Component({
    selector: 'app-toolbar-page-section',
    templateUrl: './toolbar-page-section.component.html',
    styleUrls: ['./toolbar-page-section.component.scss'],
    standalone: false
})
export class ToolbarPageSectionComponent implements OnInit {
  @HostBinding('class') classes = 'flex-column';

  constructor() {}

  ngOnInit(): void {}
}
